import * as React from "react";
import { forwardRef } from "react";
const SvgIconExpand2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 10, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M13.054 7.823a2.5 2.5 0 0 1-.217 1.01c-.148.344-.39.637-.695.843A1.9 1.9 0 0 1 11.11 10H1.97a1.9 1.9 0 0 1-1.03-.324 1.95 1.95 0 0 1-.696-.843 2.38 2.38 0 0 1 .282-2.455L5.096.712C5.27.49 5.49.311 5.74.187a1.81 1.81 0 0 1 1.603 0c.25.124.47.303.642.525l4.57 5.666c.325.409.5.919.5 1.445" }));
const ForwardRef = forwardRef(SvgIconExpand2);
export { ForwardRef as ReactComponent };
